import IdentityManager from "@arcgis/core/identity/IdentityManager";
import { getTokenNen } from "../apis/auth.api";
import {
  getDuLieuNenUrl,
  getRanhThuaURl,
  layTimDuongUrlTheoHaHuyen,
} from "./UrlHelper";

export const registerToken = async (maHuyen: string = "748") => {
  const serviceUrl = process.env.REACT_APP_SERVICE_URL;
  if (!serviceUrl)
    throw new Error("Service URL chưa được khai báo trong file env.");

  const mapToken = await getTokenNen(maHuyen);

  const nenUrl = getDuLieuNenUrl(maHuyen);
  const ranhThuaUrl = getRanhThuaURl();
  const timDuongUrl = layTimDuongUrlTheoHaHuyen(maHuyen);

  const ranhAuth = IdentityManager.findCredential(ranhThuaUrl);
  const timDuongAuth = IdentityManager.findCredential(timDuongUrl);
  const nenAuth = IdentityManager.findCredential(nenUrl);

  if (ranhThuaUrl && timDuongUrl && mapToken) {
    if (!ranhAuth || ranhAuth.expires <= Date.now() - 60000) {
      IdentityManager.registerToken({
        //@ts-ignore
        token: mapToken.ranhThuaToken.token,
        server: ranhThuaUrl,
      });
    }
    if (!timDuongAuth || timDuongAuth.expires <= Date.now() - 60000) {
      IdentityManager.registerToken({
        //@ts-ignore
        token: mapToken.timDuongToken,
        server: serviceUrl,
      });
    }
    if (!nenAuth || nenAuth.expires <= Date.now() - 60000) {
      IdentityManager.registerToken({
        //@ts-ignore
        token: mapToken.nenToken,
        server: serviceUrl,
      });
    }
  }
};
